import { render, staticRenderFns } from "./businessIndicatorsYs.vue?vue&type=template&id=b50aef80&scoped=true"
import script from "./businessIndicatorsYs.vue?vue&type=script&lang=js"
export * from "./businessIndicatorsYs.vue?vue&type=script&lang=js"
import style0 from "./businessIndicatorsYs.vue?vue&type=style&index=0&id=b50aef80&prod&lang=scss&scoped=true"
import style1 from "./businessIndicatorsYs.vue?vue&type=style&index=1&id=b50aef80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50aef80",
  null
  
)

export default component.exports